module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-card-weather-46259ed2f55e3f95c890f0ed519701f1.webp";